import { useEffect, useState } from 'react'
import { isBefore } from 'date-fns'
import { motion } from 'framer-motion'
import { FormattedMessage } from 'react-intl'

import { localStorageKeys } from '@/constants/keys'
import {
  Button,
  Card,
  slideInFromBottomAnimation,
  Typography,
} from '@/shared/ui'

import { Reload } from './shared/icons/outline'

export function NeedRefreshBanner() {
  const [needRefresh, setNeedRefresh] = useState(false)

  useEffect(() => {
    if (localStorage.getItem(localStorageKeys.lastBuild)) {
      const lastBuild = localStorage.getItem(localStorageKeys.lastBuild)

      if (lastBuild && isBefore(lastBuild, BUILD_DATE)) {
        setNeedRefresh(true)
      }
    } else {
      localStorage.setItem(localStorageKeys.lastBuild, BUILD_DATE)
    }
  }, [])

  const handleRefresh = () => {
    localStorage.setItem(localStorageKeys.lastBuild, new Date().toISOString())

    window.location.reload()
  }

  const handleDismiss = () => {
    setNeedRefresh(false)
  }

  if (!needRefresh) return null

  return (
    <motion.div
      variants={slideInFromBottomAnimation}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="fixed right-4 bottom-4 z-2 max-w-96"
      role="alert"
      aria-live="assertive"
    >
      <Card size="medium" className="flex flex-col gap-3 shadow-lg">
        <div className="flex flex-col gap-1">
          <Typography bold>
            <FormattedMessage
              defaultMessage="New version available"
              id="refresh-notification.new-version-available"
            />
          </Typography>

          <Typography className="text-neutral-gray-600" variant="body-small">
            <FormattedMessage
              id="refresh-notification.new-version-available-description"
              defaultMessage="A new version of the app is available. Refresh now to experience the latest improvements and functionalities"
            />
          </Typography>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <Button
            width="full"
            variant="secondary"
            size="sm"
            onClick={handleDismiss}
          >
            <FormattedMessage defaultMessage="Later" id="action.later" />
          </Button>
          <Button
            width="full"
            rightIcon={<Reload className="size-3" />}
            size="sm"
            onClick={handleRefresh}
          >
            <FormattedMessage defaultMessage="Refresh" id="action.refresh" />
          </Button>
        </div>
      </Card>
    </motion.div>
  )
}
